// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__pEK9j","detailsBorder":"styles_detailsBorder__1EzmB"};